import { render, staticRenderFns } from "./sms-icon.vue?vue&type=template&id=0e39e7d9"
import script from "./sms-icon.vue?vue&type=script&lang=js"
export * from "./sms-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e39e7d9')) {
      api.createRecord('0e39e7d9', component.options)
    } else {
      api.reload('0e39e7d9', component.options)
    }
    module.hot.accept("./sms-icon.vue?vue&type=template&id=0e39e7d9", function () {
      api.rerender('0e39e7d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/notifications/sms-icon.vue"
export default component.exports